import { LEGAL_VERSION } from '@brechoflow/contracts';

/*
 * Dados institucionais usados nas páginas /privacidade e /termos, no aceite e nos rodapés.
 * A versão vigente é definida em packages/contracts (a API compara o aceite com ela).
 * Mudou o texto de forma relevante? Altere LEGAL_VERSION (contracts) e LEGAL_UPDATED_AT juntos.
 */
export { LEGAL_VERSION };

/** Data (AAAA-MM-DD) da última atualização dos textos. */
export const LEGAL_UPDATED_AT = '2026-10-23';

export const COMPANY: {
  name: string;
  contactEmail: string;
  privacyEmail: string;
  forum: string;
  /** exibidos só quando preenchidos */
  cnpj?: string;
  address?: string;
} = {
  name: 'Capricornio Tech',
  contactEmail: 'contato@capricorniotech.com.br',
  privacyEmail: 'contato@capricorniotech.com.br',
  forum: 'Franca/SP',
  cnpj: undefined,
  address: undefined,
};

export const PRODUCT = {
  name: 'BrechôFlow AI',
  shortName: 'BrechôFlow',
  domain: 'brechoflow.capricorniotech.com.br',
  /** quem contrata e usa o sistema */
  customer: 'loja',
  customerPlural: 'lojas',
} as const;

export const LEGAL_ROUTES = { privacy: '/privacidade', terms: '/termos', accept: '/aceitar-termos' } as const;

/** AAAA-MM-DD -> DD/MM/AAAA (sem fuso: a data é um rótulo, não um instante). */
export function formatLegalDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
